<div id="wrap-index" class="wrapheight">
  <div class="imagemLogin"></div>
  <div id="login">
    <div class="loginContent">
      <h1>Login</h1>
      <form class="box login" [formGroup]="form" (ngSubmit)="login()">

        <div class="form-group full-width">
          <input
            placeholder="CPF"
            mask="000.000.000-00"
            type="text"
            formControlName="cpf"
            />
            <small>Somente Números</small>
          </div>

          <div class="form-group full-width">
            <input
              placeholder="Senha"
              [type]="inputSenhaType"
              formControlName="senha"
              />
            </div>

            <div class="checkbox">
              <label>
                <input type="checkbox" (click)="onChangeExibirSenha($event.target.checked)">
                <small style="display: inline-block;">&nbsp;Exibir senha</small>
              </label>
            </div>

            <div class="text-danger text-center full-width erro-servidor" [ngStyle]="{'visibility': msgErro==null ? 'hidden' : 'visible' }">
              {{msgErro}}
            </div>
            <div class="recaptcha-container">
              <ngx-recaptcha2
                siteKey="6LdaOQosAAAAACzh0-1jawKR-9YFKh57oiyDVaMg"
                [useGlobalDomain]="false"
                formControlName="recaptchaV2">
              </ngx-recaptcha2>
            </div>

            <button type="submit" class="btn_verde" [disabled]="!form.valid || loading">
              ENTRAR  @if (loading) {
              <i class="fas fa-spinner fa-spin"></i>
            }
          </button>

        </form>
        
          <!-- routerLink="/pre-adesao/cpf" routerLinkActive="active" -->
        
        <span>
          Ainda não tem conta?
          <a
            href="https://materiais.fundacaosanepar.com.br/adesao-viva-mais"

          >
            Cadastre-se grátis
          </a>
        </span>

        <div class="mais-opcoes">
          <span>
            <a routerLink="/autenticacao/esqueci-minha-senha-enviar-email" routerLinkActive="active">
              Esqueci minha senha
            </a>
          </span>

          <span>
            <a routerLink="/autenticacao/reenviar-token-email" routerLinkActive="active">
              Reenviar email de validação
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
